import React from 'react';
import { Typography } from '@mui/material';

const CustomerSupportRequests = () => (
  <Typography variant="h2">Customer Support Requests</Typography>
);

export default CustomerSupportRequests;
